<template>
  <div>
    <mdb-tabs v-if="training && training._id"
      :active="this.active" @activeTab="onActiveTab" default class="mb-3"
      :links="[
        { text: '과목별 평가'},
        { text: '학생별 평가'}
      ]"/>
      <div v-if="training && training._id">
        <router-view></router-view>
      </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'StaffTestPage',
  components: { mdbTabs },
  data: () => ({
    routeName: ['StaffTestSummaryBySubject', 'StaffTestSummaryByStudent']
  }),
  computed: {
    ...mapState('training', ['training']),
    active () {
      return this.$route.name === 'StaffTestSummaryBySubject' ? 0 : 1
    }
  },
  methods: {
    onActiveTab (index) {
      if (this.active !== index) {
        this.$router.push({ name: this.routeName[index] })
      }
    }
  }
}
</script>
